/* eslint-disable no-bitwise */
<template>
  <div class="editor-wrapper">
    <span class="d-none">{{ height }}</span>
    <div class="restsheet-editor" ref="editor" />
    <Button
      :dynamicAttrs="{class: 'blank-button btn-resize-editor'}"
      @mousedown="dragStart($event)"
      @mouseup="dragEnd($event)"
    >
      Resize
    </Button>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, ref, Ref, onMounted, onUpdated
} from 'vue';
import * as monaco from 'monaco-editor';
import Button from '@/components/Button/template.vue';
import './styles.scss';

export default defineComponent({
  name: 'Editor',
  components: {
    Button,
  },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    language: {
      type: String,
      default: 'sql',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
    runCallback: {
      type: Function,
      default: null,
    },
    isShouldUpdateContent: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const editor: Ref<any | null> = ref(null);
    let isAlreadyRunCallback = false;
    let instance: any;
    onMounted(() => {
      instance = monaco.editor.create(editor.value as any, {
        value: props.modelValue,
        language: props.language,
        readOnly: props.readOnly,
        theme: props.darkMode ? 'vs-dark' : 'vs',
        fontSize: 16,
        fontFamily: 'Inconsolata',
        minimap: {
          enabled: false,
        },
        folding: false,
        glyphMargin: false,
      });
      instance.onDidChangeModelContent(() => {
        const value = instance.getValue();
        console.log('onDidChangeModelContent', props.modelValue);
        emit('update:modelValue', value);
      });

      instance.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.Enter, () => {
        console.log('HANDLED: CTRL + ENTER');
      });

      instance.onKeyDown((e: any) => {
        if (e.ctrlKey && e.keyCode === monaco.KeyCode.Enter) {
          if (!isAlreadyRunCallback) {
            props.runCallback();
            isAlreadyRunCallback = true;
          }
          e.preventDefault();
        }
      });

      instance.onKeyUp((e: any) => {
        if (e.ctrlKey && e.keyCode === monaco.KeyCode.Enter) {
          isAlreadyRunCallback = false;
          e.preventDefault();
        }
      });
    });

    onUpdated(() => {
      const { isShouldUpdateContent, modelValue } = props;
      instance.layout();
      // Have to this flag for binding data from model, Unless user can't typing on editor
      if(isShouldUpdateContent) instance.setValue(modelValue);
    });


    return {
      editor,
      instance,
    };
  },
  data() {
    return {
      height: 200,
      currentHeight: 200,
      startY: 0,
      endY: 0,
    }
  },
  methods: {
    dragStart(e: any) {
      document.documentElement.addEventListener('mousemove', this.doDrag, false);
      document.documentElement.addEventListener('mouseup', this.dragEnd, false);
      this.startY = e.clientY;
      this.currentHeight = this.height;
    },
    doDrag(e: any) {
      const min = 200;
      const max = 600;

      let finalHeight =  this.currentHeight + (e.clientY - this.startY);
      if(finalHeight < min) finalHeight = min;
      if(finalHeight > max) finalHeight = max;
      this.height = finalHeight;
       if(this.editor) {
        this.editor.style.height = `${this.height}px`;
      }
    },
    dragEnd(e: any) {
      document.documentElement.removeEventListener('mousemove', this.doDrag, false);
      document.documentElement.removeEventListener('mouseup', this.dragEnd, false);
      this.endY = e.clientY;
    },
  },
});
</script>
